module.exports = __webpack_public_path__ + "assets/dashboard.ff8fda86.svg";